const resource = 'deals';

export default ($axios) => ({
	getDeals(params={}) {
		return $axios.get(`/${resource}`, { params });
	},

	getDeal(id) {
		return $axios.get(`/${resource}/${id}`);
	},
	getDealMedia(dealId) {
		return $axios.get(`/${resource}/${dealId}/media`);
	},
	// PUT
	updateDeal(dealData) {
		return $axios.put(`/${resource}/${dealData.id}`, dealData)
	},
	// POST
	createDeal(dealData) {
		return $axios.post(`/${resource}`, dealData)
	},
})